module.exports = __webpack_public_path__ + "img/chelsea-blecha-bungalow.d58dab7.jpg";